
import DashboardLayout from '@/components/layouts/DashboardLayout.vue'
import TheSidebar from '@/components/messenger/Sidebar.vue'
export default {
  components: {
    TheSidebar,
    DashboardLayout
  },
  setup(): unknown {
    return {}
  }
}
